import awsconfig from './aws-exports';

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
      // [::1] is the IPv6 localhost address.
      window.location.hostname === '[::1]' ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
  );

const isDev = Boolean(
    window.location.hostname.match(/dev/)
);  
  
  // Assuming you have two redirect URIs, and the first is for localhost and second is for production
  const [
    localRedirectSignIn,
    productionRedirectSignIn,
    devRedirectSignIn,
  ] = awsconfig.oauth.redirectSignIn.split(',');
  
  const [
    localRedirectSignOut,
    productionRedirectSignOut,
    devRedirectSignOut,
  ] = awsconfig.oauth.redirectSignOut.split(',');
  
 const updatedAwsConfig = {
    ...awsconfig,
    oauth: {
      ...awsconfig.oauth,
      redirectSignIn: isLocalhost ? localRedirectSignIn : (isDev ? devRedirectSignIn : productionRedirectSignIn),
      redirectSignOut: isLocalhost ? localRedirectSignOut : (isDev? devRedirectSignOut : productionRedirectSignOut),
    }
  }
  
export default updatedAwsConfig;